import { PaldeskModuleFederation } from '@paldesk/module-federation/core';
import { environment } from './environments/environment';

PaldeskModuleFederation.replaceEnvironmentFile(
  environment.production
    ? 'assets/config/config.json'
    : 'assets/config/config.development.json',
  environment,
)
  .then(() =>
    PaldeskModuleFederation.prepareHost({
      hostName: 'palshow',
      env: environment.environment,
      remotes: environment.remotes,
    }),
  )
  .then(async () => {
    if (environment.google_maps_api_key) {
      await new Promise<void>((resolve) => {
        const googleScript = document.createElement('script');
        googleScript.src = `https://maps.googleapis.com/maps/api/js?v=3.64&key=${environment.google_maps_api_key}&loading=async&libraries=places`;
        googleScript.type = 'text/javascript';
        googleScript.onload = () => resolve();
        googleScript.onerror = () => {
          console.error('Failed to load Google Maps API');
          resolve();
        };
        document.body.appendChild(googleScript);
      });
    }
  })
  .then(() => import('./bootstrap'));
